<template>
  <div id="login">

    <div class="title-box">
      <div class="logo-box">
        <span>M</span>
        <span>E</span>
        <span>G</span>
        <span>A</span>
        <span>B</span>
        <span>O</span>
        <span>X</span>
        <span>H</span>
        <span>O</span>
        <span>M</span>
        <span>E</span>
      </div>

      <h3>내집을 영화관처럼</h3>
    </div>

    <!--  Btn-group Start -->
    <div class="btn-group">
      <router-link to="/signup" class="btn btn1">로 그 인</router-link>
      <a href="#" class="btn btn2">계정 만들기</a>
      <span>또는</span>
      <a href="#" class="btn btn2">1초 안에 메가박스 계정 연동</a>
    </div>


    <!-- Bar -->
    <div class="bar"></div>

  </div>
</template>

<script>
export default {
  name: "Login"
}
</script>

<style lang="scss" scoped>
@import "../sass/partials/mixin", "../sass/partials/variable";

#login{ 
    position: relative;
    .title-box{
      top:80px;
      -webkit-transform: none;
      -moz-transform: none;
      -o-transform: none;
      transform: none;
    }

    // Button Group
    .btn-group{
      width: 100%;
      height: auto;
      padding: 0 15px;
      position: absolute; left: 0; bottom: 35px;
      .btn1{
        margin-bottom: 10px;
      }

      span{
        display: block;
        margin: 35px 0;
        height: 21px;
        text-align: center;
        color : darken(#fff, 50%);


        @include font-set(bold, $fz1, 21px, $ff1);
        
      }
    }
  }


</style>


// WEBPACK FOOTER //
// src/components/Login.vue